export default __webpack_public_path__ + "static/media/diamond.c34d9592.png";